import { profileAPI, usersAPI } from "../api/api"

const ADD_POST = 'profile/ADD-POST'
const SET_PROFILE = 'profile/SET_PROFILE'
const SET_STATUS = 'profile/SET_STATUS'
const DELETE_POST = 'profile/DELETE_POST'

let initialState = {
  posts: [],
  profile: null,
  status: null,
  newPostText: 'hello',
}

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_POST: {
      let newPost = {
        id: action.count++,
        name: state.profile.fullName,
        body: action.body
      };
      return {
        ...state,
        posts: [...state.posts, newPost],
      }
    }
    case SET_PROFILE: {
      return {
        ...state,
        profile: action.profileObj
      };
    }
    case SET_STATUS: {
      return {
        ...state,
        status: action.status
      };
    }
    case DELETE_POST: {
      return {
        ...state,
        posts: state.posts.filter(p => p.id !== action.postId)
      };
    }
    default:
      return state;
  }
}

export const addPostCreator = (body, count) => ({ type: ADD_POST, body, count })
export const setProfile = (profileObj) => ({ type: SET_PROFILE, profileObj })
const setStatus = (status) => ({ type: SET_STATUS, status })
export const deletePost = (postId) => ({ type: DELETE_POST, postId })

export const addPost = (post) => (dispatch) => {
  dispatch(addPostCreator(post));
}

export const getProfile = (userId = 23321) => async (dispatch) => {
  let response = await usersAPI.setUsers(userId)
  dispatch(setProfile(response))
}

export const getStatus = (userId = 23321) => async (dispatch) => {
  let response = await profileAPI.getStatus(userId)
  dispatch(setStatus(response))
}

export const updateStatus = (status) => async (dispatch) => {
  let response = await profileAPI.updateStatus(status)
  response.resultCode === 0 && dispatch(setStatus(response))
}

export default profileReducer;